module.exports = __webpack_public_path__ + "img/topup-card2.f37f6469.svg";